<template>
  <div>
    <v-layout
      row
      class="mx-3 vertical-align"
      color="red"
      :style="{borderBottom: '1px solid grey'}"
    >
      <v-flex
        xs11
        class="pt-1 pb-4"
      >
        <div class="title-text barlow-font">
          {{ scheduleClosingTask.proposedClosingTime == null || scheduleClosingTask.proposedClosingTime == '' ? 'Schedule ' : '' }}Closing Appointment
        </div>
        <div
          v-if="scheduleClosingTask.completed"
          class="subtitle-text barlow-font"
          :style="{ color: successColor }"
        >
          Scheduled for {{ formatSubheadingDate() }}
        </div>
        <div
          v-else
          class="subtitle-text barlow-font"
        >
          Schedule a time to close on your home
        </div>
      </v-flex>
    </v-layout>
    <div>
      <!-- This container holds the data for if the task has had no progress on it (not proposed, confirmed, or completed) -->
      <v-container
        v-show="scheduleClosingTask.proposedClosingTime == null || scheduleClosingTask.proposedClosingTime == ''"
        :class="{'pb-6 pt-3 px-6': $vuetify.breakpoint.mdAndUp, 'pb-6 pt-3': $vuetify.breakpoint.smAndDown}"
        column
      >
        <v-flex class="header-text barlow-condensed-font">
          {{ getCongratsMessage() }}
        </v-flex>

        <v-container
          class="pa-0 mt-4"
          :style="{'display': $vuetify.breakpoint.mdAndUp ? 'flex' : '', 'text-align': ($vuetify.breakpoint.smAndDown ? 'center' : '')}"
        >
          <div
            :class="{'pa-0 mb-4': $vuetify.breakpoint.smAndDown}"
            :style="{'display': 'inline-block', 'margin-right': ($vuetify.breakpoint.smAndDown ? '0px' : '32px'), 'background-color': 'grey', 'width': ($vuetify.breakpoint.smAndDown ? '180px' : '160px'), 'height': ($vuetify.breakpoint.smAndDown ? '180px' : '160px')}"
          />

          <div :style="{'flex': 1, 'width': ($vuetify.breakpoint.smAndDown ? 'auto' : '440px')}">
            <div
              class="barlow-font"
              style="text-align: left;"
            >
              <p v-html="getBody(formatDate(scheduleClosingTask.closingDate))" />
            </div>
            <div style="width: 100%; display: flex;">
              <v-btn
                outline
                :style="{'flex': 1, 'border-radius': '0px', 'background-color': 'black !important', 'height': '52px'}"
                tile
                :class="{'schedule-button my-3 mx-0': $vuetify.breakpoint.mdAndUp, 'my-3 mx-0': $vuetify.breakpoint.smAndDown}"
                @click.stop="gotoDialog"
              >
                <span
                  class="barlow-condensed-font"
                  style="font-size: 20px; font-weight: 500; color: white; letter-spacing: 1.5px"
                >{{ getButtonText() }}</span>
              </v-btn>
            </div>
          </div>
        </v-container>
      </v-container>

      <!-- This container is for after the borrower has requested a time, but hasn't confirmed it -->
      <v-container
        v-show="(scheduleClosingTask.proposedClosingTime != null && scheduleClosingTask.proposedClosingTime != '') && (scheduleClosingTask.completed == null || !scheduleClosingTask.completed)"
        :class="{'pb-6 pt-0 px-6': $vuetify.breakpoint.mdAndUp}"
        column
      >
        <v-flex class="header-text barlow-condensed-font">
          Does this look right?
        </v-flex>

        <v-container
          class="look-right-container px-3 mt-3"
          style="padding-top: 19px important!; display: flex;"
        >
          <div style="flex: 4;">
            <div
              style="font-weight: 500; font-size: 13px; line-height: 18px;"
              class="barlow-font"
            >
              You have chosen to {{ getCloseType() }}
            </div>
            <div
              style="margin-top: 3px; font-weight: 500; font-size: 16px; line-height: 21px;"
              class="barlow-font"
            >
              {{ formatProposedClosingTime() }} ({{ getTimeZone() }})
            </div>
          </div>

          <div
            style="display: block; flex: 1; text-align: center; margin: auto !important;"
            class="ma-0 pa-0"
            justify-end
          >
            <v-btn
              v-if="$vuetify.breakpoint.mdAndUp"
              outline
              style="border-radius: 0px; background-color: white !important;"
              tile
              class="edit-button ma-0"
              @click.stop="gotoDialog"
            >
              <span
                class="barlow-condensed-font"
                style="font-size: 15px; font-weight: 600;"
              >
                Edit
              </span>
            </v-btn>
            <v-icon
              v-else
              size="18"
              style="background-color: white !important;"
              class="outlined"
              color="black"
              @click.stop="gotoDialog"
            >
              {{ $vuetify.icons['sn-icon-pencil'] }}
            </v-icon>
          </div>
        </v-container>

        <v-container class="pa-0 mt-3">
          <span
            style="font-size: 17px; line-height: 22px; font-weight: 400;"
            class="barlow-font"
          >
            You'll need to contact your settlement agent to make changes after your appointment request is sent.
          </span>
        </v-container>

        <v-container
          class="footer-container pa-0 pb-4"
          style="display: flex;"
        >
          <div
            v-show="false"
            style="flex: 1"
            justify-start
            class="mt-4"
          >
            <v-btn
              style="border: 0px !important; border-radius: 0px"
              outline
              tile
              small
              class="ask-question-button ma-0"
            >
              <v-icon class="pr-1">
                {{ $vuetify.icons['sn-icon-chat'] }}
              </v-icon>
              <span
                style="font-size: 15px; font-weight: 600; line-height: 20px;"
                class="barlow-font"
              >
                ASK A QUESTION
              </span>
            </v-btn>
          </div>

          <div
            :style="{'flex': 1, 'display': 'flex', 'position': ($vuetify.breakpoint.smAndDown ? 'relative' : 'absolute'), 'right': ($vuetify.breakpoint.smAndDown ? '' : '64px'), 'text-align': ($vuetify.breakpoint.smAndDown ? 'center' : 'auto')}"
            class="mt-5"
          >
            <v-btn
              style="flex: 1; width: 224px; height: 52px; border: 0px !important; border-radius: 0px; background-color: black !important;"
              outline
              tile
              small
              class="ma-0"
              @click.stop="completeTask"
            >
              <span
                style="font-size: 15px; color: white !important; font-weight: 600; line-height: 20px; letter-spacing: 1.5px;"
                class="barlow-font"
              >
                REQUEST APPOINTMENT</span>
            </v-btn>
          </div>
        </v-container>
      </v-container>

      <!-- This container is for after the borrower has confirmed their requested time -->
      <v-container
        v-show="scheduleClosingTask.completed"
        :class="{'pb-6 pt-0 px-6': $vuetify.breakpoint.mdAndUp}"
        column
      >
        <v-flex class="header-text barlow-condensed-font">
          Your appointment request is {{ scheduleClosingTask.confirmed ? 'confirmed!' : 'being reviewed.' }}
        </v-flex>

        <v-container
          class="look-right-container px-3 mt-3"
          style="padding-top: 19px important!; display: flex;"
        >
          <div style="flex: 4;">
            <div
              style="font-weight: 500; font-size: 13px; line-height: 18px;"
              class="barlow-font"
            >
              You have chosen to {{ getCloseType() }}
            </div>
            <div
              style="margin-top: 3px; font-weight: 500; font-size: 16px; line-height: 21px;"
              class="barlow-font"
            >
              {{ formatProposedClosingTime() }}
            </div>
          </div>
        </v-container>

        <v-container class="pa-0 mt-3">
          <span
            style="font-size: 17px; line-height: 22px; font-weight: 400;"
            class="barlow-font"
          >
            Please contact your settlement agent if you need to make changes.
          </span>
        </v-container>

        <v-container
          class="footer-container pa-0"
          :style="{'display': 'flex', 'text-align': ($vuetify.breakpoint.smAndDown ? 'center' : 'left')}"
        >
          <div
            v-show="true"
            style="display: flex; flex: 1"
            justify-start
            class="mt-4"
          >
            <v-btn
              :style="{'border': ($vuetify.breakpoint.smAndDown ? '1px solid !important' : '0px !important'), 'border-radius': '0px', 'flex': 1, 'height': '32px'}"
              outline
              tile
              small
              class="ask-question-button ma-0"
            >
              <v-icon class="pr-1">
                {{ $vuetify.icons['sn-icon-chat'] }}
              </v-icon>
              <span
                style="font-size: 15px; font-weight: 600; line-height: 20px;"
                class="barlow-font"
              >
                CHAT WITH SETTLEMENT AGENT
              </span>
            </v-btn>
          </div>
        </v-container>
      </v-container>
    </div>
  </div>
</template>

<script>
import { completeScheduleCloseTask } from './mutations.gql'
import { borrowerScheduleClosingTaskQuery } from './queries.gql'

export default {
  components: { },
  props: { },
  data () {
    return {
      scheduleDialog: true,
      taskConfirmedByBorrower: false
      // taskConfirmedByBorrower: this.scheduleClosingTask.completed,
    }
  },
  computed: {
    successColor () {
      return this.$vuetify.theme.success
    }
  },
  apollo: {
    scheduleClosingTask: {
      query: borrowerScheduleClosingTaskQuery,
      fetchPolicy: 'network-only',
      variables () {
        return {
          guid: this.$route.params.taskGuid
        }
      },
      update (data) {
        this.$emit('hideLoader')
        return data.scheduleClosingTask
      }
    }
  },
  methods: {
    formatDate (date) {
      return this.$moment(date).format('MMM Do, YYYY')
    },
    formatProposedClosingTime () {
      const day = this.$moment(this.task.proposedClosingTime).format('ddd, MMM Do, YYYY')
      const startTime = this.$moment(this.task.proposedClosingTime).format('h:mm a')
      const endTime = this.$moment(this.task.proposedClosingTime).add(1, 'hours').format('h:mm a')
      return `${day}, ${startTime.toUpperCase()} - ${endTime.toUpperCase()}`
    },
    formatSubheadingDate () {
      return this.$moment(this.scheduleClosingTask.proposedClosingTime).format('DD.MMM.YYYY').toString().toUpperCase()
    },
    completeTask () {
      this.$apollo.mutate({
        mutation: completeScheduleCloseTask,
        variables: {
          guid: this.scheduleClosingTask.guid
        }
      }).then((result) => {
        this.taskConfirmedByBorrower = true
        this.$emit('navigation', 'close')
      })
    },
    getCongratsMessage () {
      if (this.task.onlineEligible) {
        return 'Congratulations! Your loan is eligible to close online.'
      } else if (this.task.hybridEligible) {
        return "Congratulations! You're almost ready to close."
      } else if (this.task.ronEligible) {
        return 'Congratulations! Your closing is ready to go.'
      } else {
        return "Congratulations! You're almost ready to close."
      }
    },
    getBody (date) {
      if (date === '' || date == null) { date = 'soon' }

      if (this.task.onlineEligible || this.task.ronEligible) {
        return `You are scheduled to close <b>${date}</b>.<br/><br/>You can close faster and from the comfort of your own living space when you choose to close online. And don't worry - someone will always be there to help!<br/><br/>Not comfortable closing online? You can still choose to schedule an in-person closing appointment.`
      } else {
        return `You are scheduled to close <b>${date}</b>.`
      }
    },
    getButtonText () {
      if (this.task.onlineEligible || this.task.ronEligible) {
        return 'SCHEDULE MY CLOSING'
      } else {
        return 'SCHEDULE APPOINTMENT TIME'
      }
    },
    getCloseType () {
      if (this.task.closeType === 'traditional') { return 'close in person' } else if (this.task.closeType === 'online') { return 'eClose online' }
    },
    dialogCompleted () {
      if (this.scheduleClosingTask.proposedClosingTime != null) {
        this.scheduleDialog = false
      }
      this.$emit('completed')
    },
    getTimeZone () {
      var zone = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]
      return zone
    },
    gotoDialog () {
      this.$emit('showLoader')
      this.$emit('navigation', 'SC_dialog')
    }
  }
}
</script>

<style>
.title-text {
  font-weight: 600;
  font-size: 17px;
  color: black;
}
.subtitle-text {
  font-size: 15px;
  font-weight: 500;
  color: #A5A5A5;
}
.v-icon.outlined {
  border: 1px solid currentColor;
  border-radius:50%;
  height: 28px;
  width: 28px;
}
.header-text {
  font-size: 32px;
  font-weight: 200;
}
.schedule-button {
  height: 52px;
  width: 440px;
  border-radius: 0px;
  background-color: black !important;
}
.body-container {
  flex: 1;
}
.look-right-container {
  background-color: #f2f2f2 !important;
  border-radius: 4px !important;
}
.edit-button {
  height: 32;
  width: 132px;
  letter-spacing: 1.5px;
}
.footer-container {
  margin-top: 35px !important;
  border: 0px;
  border-top: 1px solid grey;
}
.barlow-font {
  font-family: "Barlow", sans-serif !important;
}
.barlow-condensed-font {
  font-family: "Barlow Condensed", sans-serif !important;
}

</style>
